import React, { useCallback, useMemo } from "react";
import { Platform } from "react-native";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { Spinner } from "@lookiero/aurora";
import { Locale } from "@lookiero/sty-psp-locale";
import { sentryLoggerHOC, sentryLogger, } from "@lookiero/sty-psp-logging/sentry";
import { i18n } from "./i18n/i18n";
import { LookAndLike } from "./views/LookAndLike";
const root = ({ Messaging, development, sentry }) => {
    const logger = sentryLogger(sentry);
    const Root = ({ locale = Locale.en_GB, tradename, ...props }) => {
        const handleOnI18nError = useCallback((error, fingerprint) => logger.captureException(error, fingerprint ? { captureContext: { fingerprint: [...fingerprint] } } : undefined), []);
        const I18nComponent = useMemo(() => i18n({ tradename }), [tradename]);
        return (React.createElement(Messaging, { includeReactQueryDevTools: Platform.OS === "web" },
            React.createElement(I18nComponent, { loader: React.createElement(Spinner, null), locale: locale, onError: development ? undefined : handleOnI18nError },
                React.createElement(SafeAreaProvider, null,
                    React.createElement(LookAndLike, { ...props })))));
    };
    const hoc = sentryLoggerHOC({ logger });
    /**
     * It's important to not call sentryLoggerHOC each time this function gets called.
     * That's why its called outside this method.
     */
    return ({ customerId }) => hoc({ customerId })(Root);
};
export { root };
